<template>
  <div>
    <component :is="component" />
  </div>
</template>

<script>
  import neuralNetwork from '@/views/settings/agents/agent/search/neuralNetwork.vue';
  import regularExpressions from '@/views/settings/agents/agent/search/regularExpressions.vue';
  import compoundRules from '@/views/settings/agents/agent/search/compoundRules.vue';

  export default {
    data: () => ({}),
    computed: {
      component() {
        switch (this.$route.params.log) {
          case 'neuralNetwork':
            return neuralNetwork;
          case 'regularExpressions':
            return regularExpressions;
          case 'compoundRules':
            return compoundRules;
          default:
            throw Error(`Unknown default log ${this.$route.params.log}`);
        }
      },
    },
  };
</script>
